
<main>
    <div class="memberList">
        <a routerLink="/committee/main-member-list" class="list-item">
            <h4>કુટુંબના મુખ્ય સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>

        <a routerLink="/committee/all-member-list" class="list-item">
            <h4>કુટુંબના બધા સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>

        <a routerLink="/committee/activist-member" class="list-item" *ngIf="userTypeId == 1">
            <h4>સભ્યોને કમિટી માં ફેરવો</h4>
            <i class="ti ti-chevron-right"></i>
        </a>

        <a routerLink="/nri-memberlist" class="list-item">
            <h4>NRI સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a>

        <!-- <a routerLink="/committee/main-member-list" class="list-item">
            <h4>કૌટુંબિક સલાહકારોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
        <!-- <a routerLink="/committee/isactive" class="list-item">
            <h4>અમાન્ય સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
        <!-- <a routerLink="/committee/main-member-list" class="list-item">
            <h4>કુટુંબની કાર્યકારી વ્યક્તિઓની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
        <!-- <a routerLink="/committee/village-list" class="list-item">
            <h4>ગામ ના સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
        <!-- <a routerLink="/committee/main-member-list" class="list-item">
            <h4>શહેર ના સભ્યોની યાદી</h4>
            <i class="ti ti-chevron-right"></i>
        </a> -->
    </div>
</main>